/*
 * The register view's english translation.
 */
export const REGISTER_VIEW_EN = {
  startYourJourneyWith: 'Start your journey with',
  registerYourAccountAndSelectYourProductAndSubscription:
    'Register your account and select your product and subscription plan',
  prices: 'Price(s)',
  perMonth: 'per month',

  oneMonth: 'Monthly',
  twelveMonths: '12 Months',
  twentyfourMonths: '24 Months',

  oneTimePayment: 'One-time payment',
  dyn: {
    TODO: {
      howManyAccountsShouldOrgaHaveUpToFive:
        'How many accounts should your Organisation have? Up to 5 seats',
      describeSpecificRequirementsAndNeeds: 'Please describe your specific requirements and needs'
    }
  },
  enterFullName: 'Enter your full name',
  confirmYourPassword: 'Confirm your password',
  contactUs: 'Contact Us for your own Newsroom',
  name: 'Name',
  backToAllProducts: 'Back to all products',
  accountCreation: 'Account Creation',
  registerFillAllFields: 'Please fill in all fields.',
  registerAcceptTerms: 'Please accept the terms and conditions.',
  registerFailedGeneric: 'Registration failed. Please try again.',
  registerEnterCode: 'Please enter the code.',
  registerFillBothPasswords: 'Please fill in both password fields.',
  registerPasswordsDoNotMatch: 'Passwords do not match.',
  registerAuthErrorRetryCode: 'Authentication error. Please try logging in with the code again.',
  registerSuccessToast: 'Registration successful!',
  registerSetPasswordFailed: 'Failed to set password. Please try again.',
  emailAddress: 'Email address',
  byCreating: 'by creating an account with newsrooms you agree to have read and understood our',
  registerConsentTail: '.',
  registerBusinessOnly: 'This service is intended for business use only, not for consumers.',
  iHaveAffiliateCode: 'I have an affiliate code',
  enterCode: 'Enter Code',
  codeDescription:
    'We sent you an E-Mail with a temporary password or code. If you cannot find it, check the spam folder!',
  codeFallbackHint: 'Did not receive a code? If this email is already registered, sign in instead.',
  useDifferentEmail: 'Use a different email',
  signInInstead: 'Sign in',
  codeRetryOrSignIn: 'Invalid or expired code. Please try again, or sign in instead.',
  codeRecoveryAfterFailure:
    'If the code does not arrive, return and register with another email, or sign in with your existing account.',
  code: 'Code',
  passwordTitle: 'Password',
  passwordDescription: 'Please create a password for your newsrooms account.',
  repeatPassword: 'Repeat Password',
  enter: 'Enter'
}
/*
 * The register view's german translation.
 */
export const REGISTER_VIEW_DE = {
  startYourJourneyWith: 'Starte deine Reise mit',
  registerYourAccountAndSelectYourProductAndSubscription:
    'Registriere dich und wähle dein Produkt und Abo-Modell',
  prices: 'Preis',
  perMonth: 'pro Monat',

  oneMonth: 'Monatlich',
  twelveMonths: '12 Monate',
  twentyfourMonths: '24 Monate',

  oneTimePayment: 'Einmalzahlung',
  dyn: {
    TODO: {
      howManyAccountsShouldOrgaHaveUpToFive:
        'Wie viele Nutzer soll deine Organisation haben? Bis zu 5 möglich',
      describeSpecificRequirementsAndNeeds: 'Beschreibe deine spezifischen Anforderungen'
    }
  },
  enterFullName: 'Gib deinen vollständigen Namen ein',
  confirmYourPassword: 'Bestätige dein Passwort',
  contactUs: 'Kontaktiere uns für eine individuelle Lösung',
  name: 'Name',
  backToAllProducts: 'Zurück zu allen Produkten',
  accountCreation: 'Konto erstellen',
  registerFillAllFields: 'Bitte füllen Sie alle Felder aus.',
  registerAcceptTerms: 'Bitte akzeptieren Sie die Nutzungsbedingungen.',
  registerFailedGeneric: 'Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
  registerEnterCode: 'Bitte geben Sie den Code ein.',
  registerFillBothPasswords: 'Bitte füllen Sie beide Passwortfelder aus.',
  registerPasswordsDoNotMatch: 'Die Passwörter stimmen nicht überein.',
  registerAuthErrorRetryCode:
    'Authentifizierungsfehler. Bitte melden Sie sich erneut mit dem Code an.',
  registerSuccessToast: 'Registrierung erfolgreich!',
  registerSetPasswordFailed:
    'Das Passwort konnte nicht gesetzt werden. Bitte versuchen Sie es erneut.',
  emailAddress: 'E-Mail Adresse',
  byCreating: 'Mit der Erstellung eines Kontos bei newsrooms bestätigen Sie, dass Sie unsere',
  registerConsentTail: 'gelesen haben und akzeptieren.',
  registerBusinessOnly:
    'Dieser Service richtet sich ausschließlich an Unternehmen, nicht an Verbraucher.',
  iHaveAffiliateCode: 'Ich habe einen Empfehlungscode',
  enterCode: 'Code eingeben',
  codeDescription:
    'Wir haben Ihnen eine E-Mail mit einem temporären Passwort oder Code gesendet. Falls Sie sie nicht finden, prüfen Sie bitte auch den Spam-Ordner.',
  codeFallbackHint:
    'Keinen Code erhalten? Falls diese E-Mail bereits registriert ist, melden Sie sich stattdessen an.',
  useDifferentEmail: 'Andere E-Mail nutzen',
  signInInstead: 'Anmelden',
  codeRetryOrSignIn:
    'Code ungültig oder abgelaufen. Bitte versuchen Sie es erneut oder melden Sie sich stattdessen an.',
  codeRecoveryAfterFailure:
    'Falls kein Code ankommt, gehen Sie zurück, registrieren Sie sich mit einer anderen E-Mail oder melden Sie sich mit Ihrem bestehenden Konto an.',
  code: 'Code',
  passwordTitle: 'Passwort',
  passwordDescription: 'Bitte erstellen Sie ein Passwort für Ihr newsrooms-Konto.',
  repeatPassword: 'Passwort wiederholen',
  enter: 'Eingeben'
}
